import { createSvgIcon } from '@automata/mui-theme';
export const InhecoScilaco2Icon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M57.0032 12.7314L20.5 33.8648V37.691C20.5 38.4485 20.072 39.1411 19.3944 39.4798L18.5 39.9271V73.6385L35.0294 83.2806L40.5481 80.309C41.1482 79.9858 41.8717 79.9906 42.4675 80.3216L45.9847 82.2756L82.5 61.1352V27.3685L57.0032 12.7314ZM55.999 9.8463C56.6166 9.48874 57.3779 9.48735 57.9968 9.84264L84.4957 25.055C85.1169 25.4116 85.5 26.0732 85.5 26.7895V61.7117C85.5 62.4254 85.1197 63.085 84.5021 63.4426L46.997 85.1561C46.3881 85.5086 45.6387 85.5152 45.0236 85.1735L41.4888 83.2097L35.958 86.1878C35.3447 86.5181 34.6037 86.5054 34.002 86.1544L16.4923 75.9404C15.8778 75.582 15.5 74.9242 15.5 74.2128V39.309C15.5 38.5515 15.928 37.859 16.6056 37.5202L17.5 37.073V33.2883C17.5 32.5746 17.8803 31.915 18.4979 31.5574L55.999 9.8463Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M83.8648 26.4975C84.1423 26.975 83.9801 27.5871 83.5026 27.8645L46.7482 49.2218C46.2912 49.4874 45.7282 49.4928 45.2661 49.2361L41.5348 47.1632L36.7941 50.18C36.3204 50.4814 35.718 50.4931 35.233 50.2101L18.171 40.2573C17.2256 39.7058 17.17 38.3604 18.0666 37.7328L21.1342 35.5854L19.004 34.3682C18.5245 34.0942 18.3579 33.4833 18.6319 33.0038C18.9059 32.5243 19.5168 32.3577 19.9963 32.6317L22.8114 34.2403C23.7667 34.7862 23.8287 36.1406 22.9274 36.7715L19.8534 38.9233L35.9775 48.329L40.7122 45.316C41.1764 45.0207 41.765 45.0031 42.246 45.2703L45.9891 47.3498L82.4977 26.1353C82.9753 25.8578 83.5873 26.02 83.8648 26.4975Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46 48C46.5523 48 47 48.4477 47 49V82.5C47 83.0523 46.5523 83.5 46 83.5C45.4477 83.5 45 83.0523 45 82.5V49C45 48.4477 45.4477 48 46 48Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.5 49C36.0523 49 36.5 49.4477 36.5 50V84.5C36.5 85.0523 36.0523 85.5 35.5 85.5C34.9477 85.5 34.5 85.0523 34.5 84.5V50C34.5 49.4477 34.9477 49 35.5 49Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1382 43.4929C17.4182 43.0169 18.0311 42.858 18.5072 43.138L34.9885 52.8329L40.9761 49.1483C41.4464 48.8588 42.0624 49.0055 42.3518 49.4758C42.6413 49.9462 42.4946 50.5621 42.0243 50.8516L35.7805 54.6939C35.3075 54.9849 34.7125 54.9909 34.2338 54.7093L17.4931 44.8618C17.0171 44.5818 16.8582 43.9689 17.1382 43.4929Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.5 46C42.0523 46 42.5 46.4477 42.5 47V81.5C42.5 82.0523 42.0523 82.5 41.5 82.5C40.9477 82.5 40.5 82.0523 40.5 81.5V47C40.5 46.4477 40.9477 46 41.5 46Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6319 50.0038C16.9059 49.5243 17.5168 49.3577 17.9963 49.6317L34.995 59.3452L40.4963 56.1361C40.9734 55.8579 41.5857 56.019 41.864 56.4961C42.1422 56.9731 41.9811 57.5854 41.504 57.8637L35.7534 61.2182C35.2905 61.4883 34.7187 61.4908 34.2534 61.2249L17.004 51.3682C16.5245 51.0942 16.3579 50.4833 16.6319 50.0038Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1427 56.9854C17.4268 56.5118 18.0411 56.3583 18.5146 56.6424L35.5073 66.838L40.9963 63.6361C41.4733 63.3578 42.0856 63.519 42.3639 63.996C42.6422 64.4731 42.4811 65.0854 42.004 65.3637L36.2595 68.7146C35.7868 68.9904 35.2013 68.9868 34.732 68.7052L17.4857 58.3574C17.0121 58.0733 16.8585 57.459 17.1427 56.9854Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6364 64.496C16.9147 64.019 17.527 63.8579 18.004 64.1361L35.5002 74.3422L40.9963 71.1361C41.4733 70.8579 42.0857 71.019 42.3639 71.496C42.6422 71.9731 42.4811 72.5854 42.004 72.8637L36.256 76.2167C35.7889 76.4892 35.2114 76.4892 34.7444 76.2167L16.9963 65.8637C16.5192 65.5854 16.3581 64.9731 16.6364 64.496Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6364 70.996C16.9147 70.519 17.527 70.3579 18.004 70.6361L35.5167 80.8518L40.5213 78.122C41.0062 77.8576 41.6136 78.0362 41.8781 78.5211C42.1425 79.0059 41.9639 79.6134 41.479 79.8778L36.2267 82.7427C35.7655 82.9943 35.2064 82.9862 34.7526 82.7215L16.9963 72.3637C16.5192 72.0854 16.3581 71.4731 16.6364 70.996Z"
    />
  </svg>,
  'InhecoScilaco2Icon'
);
